
// => Styling
import styles from './TitleScreen.module.css';

// => Icons
import {
    IoHandLeftOutline,
    IoBug,
} from "react-icons/io5";

// => React hooks
import { useRef, useState, useEffect } from 'react';

// => 3rd party hooks
import { useSpring, animated, config } from 'react-spring';


// ============
// Component
// ============
const TitleScreen = ({
    delay = null,
    onContinue = () => {},
}) => {

    const [delayTimer, setDelayTimer] = useState(delay)
    const refDelayTimerInterval = useRef(null)
    useEffect(() => {
        // Timer interval
        refDelayTimerInterval.current = 
            (delayTimer !== null && delayTimer > 0) &&
            setInterval(() => setDelayTimer(delayTimer - 1), 1000)

        // Check if timer reached zero
        if (delayTimer !== null && delayTimer <= 0) {
            clearInterval(refDelayTimerInterval)
        }

        return () => {
            clearInterval(refDelayTimerInterval)
        }
    }, [delayTimer])

    const refAnimFade = useRef(false)
    const [{ opacity }, springApi] = useSpring(() => ({ opacity: 1 }))

    function requestContinue() {
        if (delayTimer === null || delayTimer > 0) return;
        if (refAnimFade.current === true) return;
        
        refAnimFade.current = true
        springApi.start({
            from: {
                opacity: 1
            },
            to: {
                opacity: 0
            },
            onRest: () => {
                onContinue()
                refAnimFade.current = false
            },
            config: config.gentle
        })
    }


    // RENDER
    // ---------
    return(
        <animated.div className={[styles.container, (delayTimer !== null && delayTimer > 0) ? null : styles.ready].join(" ")}
                    onClick={()=>requestContinue()}
                    style={{ opacity }}>
            
            <div className={styles.content}>
                    <span className={styles.title}>
                        Content Warning
                    </span>

                    <div className={styles.item}>
                        <span className={styles.icon}><IoHandLeftOutline /></span>
                        <span className={styles.text}>
                            This game is intended for mature audiences only and contains explicit sexual content.<br/>
                            By continuing, <span className={styles.highlight}>you agree to be of legal age</span> to view such material.
                        </span>
                    </div>

                    <div className={styles.item}>
                        <span className={styles.icon}><IoBug /></span>
                        <span className={styles.text}>
                            Please note, this is an early development build. You will encounter <span className={styles.highlight}>unfinished features</span> and <span className={styles.highlight}>bugs</span>.
                        </span>
                    </div>
                    
                    

                    <div className={[styles.indicator, delayTimer !== null && delayTimer > 0 ? null : styles.indicatorAnimated].join(" ")}
                        >
                            Click to continue.
                    </div>
            </div>

        </animated.div>
    )
}


export default TitleScreen